import Vue from 'vue'
import Router from 'vue-router'
import Layout from '../views/layout/Layout'

Vue.use(Router);
const originalPush1 = Router.prototype.push;
const originalReplace = Router.prototype.replace;
//push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush1.call(this, location, onResolve, onReject);
  return originalPush1.call(this, location).catch(err => err);
};
//replace
Router.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch(err => err);
};
export const AllRouter = [
  {
    path: "/",
    component: Layout,
    redirect: '/home',
    children: [
      {
        path: "home",
        name: 'home',
        component: () => import('../views/home/index')
      },
      {
        path: "about",
        name: 'about',
        component: () => import('../views/about/index')
      },
      {
        path: "product",
        name: 'product',
        component: () => import('../views/product/index')
      },
      {
        path: "productDetail",
        name: 'productDetail',
        component: () => import('../views/product/detail')
      },
      {
        path: "case",
        name: 'case',
        component: () => import('../views/case/index')
      },
      {
        path: "download",
        name: 'download',
        component: () => import('../views/download/index')
      },
      {
        path: "contact",
        name: 'contact',
        component: () => import('../views/contact/index')
      },
    ]
  }
];
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  routes: AllRouter
})



// WEBPACK FOOTER //
// ./src/router/index.js